export const formatTimestamp = (minutes: number, seconds: number): string => {
	return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

export const formatDuration = (ms: number): string => {
	if (ms < 0) return '0ms';
	if (ms < 1000) {
		return `${Math.floor(ms)}ms`;
	}
	if (ms < 60000) {
		return `${(ms / 1000).toFixed(2)}s`;
	}
	const totalSeconds = Math.floor(ms / 1000);
	const minutes = Math.floor(totalSeconds / 60);
	const seconds = totalSeconds % 60;

	if (seconds === 0) {
		return `${minutes}min`;
	}

	return `${minutes}min ${seconds}s`;
};
